function CourseHeroText() {
	$('.js-course-hero-text-link').on("click", function() {
		let $this = $(this);
		let $heroText = $this.prev('.js-course-hero-text');

		if ($heroText.hasClass('is-less')) {
			$heroText.removeClass('is-less');
			$this.text('less');
		} else {
			$heroText.addClass('is-less');
			$this.text('more');
		}
	});
}

export { CourseHeroText };